export default "__VITE_ASSET__B7Wf$mQa__"